'use strict';

import angular from 'angular';

export default function($http) {
	'ngInject';

	return {
		scope: true,
		link: function(scope, element, attrs) {
			angular.element(element).on('click', () => {
				if (confirm('Are you sure you want to test the call center?')) {
					$http.post('/api/staff/test-cci/').then(
						() => {},
						(e) => {
							alert('An error ocurred.');
						}
					);
				}
			});
		},
	};
}
